// Korekta dojścia do kotwicy po WEJŚCIU na stronę z adresem zawierającym „#nazwa"
// (link „Jak to działa?" / „FAQ" kliknięty z polityki prywatności, FAQ, 404 albo z zewnątrz).
//
// Samo przewijanie po kliknięciu obsługuje CSS: `motion-safe:scroll-smooth` na <html>
// plus `scroll-mt-*` na sekcjach docelowych. Ten moduł NIE dubluje tamtej obsługi —
// zajmuje się jedynym przypadkiem, którego CSS nie domknie: przeglądarka wykonuje skok
// do kotwicy zaraz po sparsowaniu dokumentu, a obrazy sekcji kroków i karty CTA dochodzą
// PÓŹNIEJ i przesuwają cel w dół. Bez korekty użytkownik ląduje kilkaset pikseli nad sekcją,
// o którą prosił.
//
// Korekta jest SKOKOWA (`behavior: 'auto'`), a nie płynna: strona ma być już na miejscu,
// a nie odjeżdżać spod palca po wczytaniu. `auto` nadpisuje tu `scroll-behavior: smooth`
// z <html>, więc reguła CSS nie przecieka do tego wywołania.
export function initAnchorLanding() {
  const target = () => {
    const id = window.location.hash.slice(1)
    if (!id) return null
    try {
      return document.getElementById(decodeURIComponent(id))
    } catch {
      return document.getElementById(id) // hash z niepoprawnym kodowaniem procentowym
    }
  }

  if (!target()) return

  // Gdy użytkownik zdążył ruszyć stroną sam, korekta jest wyłączona — inaczej wyrywała by mu
  // widok spod ręki. Zdarzenie `scroll` do tego NIE służy: wywołuje je również skok
  // przeglądarki do kotwicy, więc flaga zapalała by się zawsze.
  let userMoved = false
  const markMoved = () => { userMoved = true }
  const opts = { once: true, passive: true }
  window.addEventListener('wheel', markMoved, opts)
  window.addEventListener('touchstart', markMoved, opts)
  window.addEventListener('keydown', markMoved, opts)

  const settle = () => {
    if (userMoved) return
    const el = target()
    if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' })
  }

  // Po `load` układ ma już zmierzone obrazy; jedna klatka zapasu na złożenie strony.
  const run = () => requestAnimationFrame(settle)
  if (document.readyState === 'complete') run()
  else window.addEventListener('load', run, { once: true })
}
